import { SEAL_SYSTEMS } from '@Constants/types';

const initialState = {
    isCheckingSSO: false,
    hasSSO: false
};

export default function ssoReducer(state = initialState, action) {
    switch (action.type) {
        case SEAL_SYSTEMS.SSO_CHECK:
            return {
                isCheckingSSO: true,
                hasSSO: false
            };

        case SEAL_SYSTEMS.SSO_CONFIGURED:
            return {
                isCheckingSSO: false,
                hasSSO: true
            };

        case SEAL_SYSTEMS.SSO_NOT_CONFIGURED:
            return {
                isCheckingSSO: false,
                hasSSO: false
            };

        default:
            return state;
    }
}
